import { render, staticRenderFns } from "./dataCashProductDetails.vue?vue&type=template&id=1e90b6b2&scoped=true"
import script from "./dataCashProductDetails.vue?vue&type=script&lang=js"
export * from "./dataCashProductDetails.vue?vue&type=script&lang=js"
import style0 from "./dataCashProductDetails.vue?vue&type=style&index=0&id=1e90b6b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90b6b2",
  null
  
)

export default component.exports